import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';
import { ConfigurationRepository }
from '../../repositories/configuration.repository';
import { DataMenuModel, MenuModel } from '../../models/configuration/menu.model';

export class
InsertMenuUseCase
implements UseCase<
DataMenuModel,
MenuModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataMenuModel
    ):
    Observable<MenuModel> {

        return this.repository.insertmenu(params);
    }
}